// @auto-index

import apkaTv from './apka-tv'
import blog from './blog'
import classicGames from './classic-games'
import fastCoffee from './fast-coffee'
import iAmRich from './i-am-rich'
import koronaKrulow from './korona-krulow'
import kwejk from './kwejk'
import musicTube from './music-tube'
import platformerGameEngine from './platformer-game-engine'
import pogaduszki from './pogaduszki'
import promegle from './promegle'
import ratingSpeed from './rating-speed'
import sandtime from './sandtime'
import storePro from './store-pro'
import testyPrawoJazdy from './testy-prawo-jazdy'

export { default as apkaTv } from './apka-tv'
export { default as blog } from './blog'
export { default as classicGames } from './classic-games'
export { default as fastCoffee } from './fast-coffee'
export { default as iAmRich } from './i-am-rich'
export { default as koronaKrulow } from './korona-krulow'
export { default as kwejk } from './kwejk'
export { default as musicTube } from './music-tube'
export { default as platformerGameEngine } from './platformer-game-engine'
export { default as pogaduszki } from './pogaduszki'
export { default as promegle } from './promegle'
export { default as ratingSpeed } from './rating-speed'
export { default as sandtime } from './sandtime'
export { default as storePro } from './store-pro'
export { default as testyPrawoJazdy } from './testy-prawo-jazdy'

export default {
  apkaTv,
  blog,
  classicGames,
  fastCoffee,
  iAmRich,
  koronaKrulow,
  kwejk,
  musicTube,
  platformerGameEngine,
  pogaduszki,
  promegle,
  ratingSpeed,
  sandtime,
  storePro,
  testyPrawoJazdy
}
